export default {
  about: "À propos",
  courses: "Cours",
  pricing: "Tarifs",
  blog: "Blog",
  contact: "Contact",
};
